module.exports = __webpack_public_path__ + "img/ve-rounded.caa9e0f9.png";